import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DraggableDirective } from '../directives/draggable/draggable.directive';
import { PhotoTransformService } from '../services/transform/photo-transform.service';
import { PhotoEditorComponent } from './photo-editor.component';

@NgModule({
    imports: [FormsModule, CommonModule],
    declarations: [PhotoEditorComponent, DraggableDirective],
    providers: [PhotoTransformService],
    exports: [PhotoEditorComponent]
})
export class PhotoEditorModule {}
